var map = {
	"./banner": "./app/javascript/images/banner.png",
	"./banner-about": "./app/javascript/images/banner-about.png",
	"./banner-about.png": "./app/javascript/images/banner-about.png",
	"./banner.png": "./app/javascript/images/banner.png",
	"./certificate": "./app/javascript/images/certificate.png",
	"./certificate-lg": "./app/javascript/images/certificate-lg.png",
	"./certificate-lg.png": "./app/javascript/images/certificate-lg.png",
	"./certificate.png": "./app/javascript/images/certificate.png",
	"./cipd": "./app/javascript/images/cipd.svg",
	"./cipd.svg": "./app/javascript/images/cipd.svg",
	"./citb": "./app/javascript/images/citb.svg",
	"./citb.svg": "./app/javascript/images/citb.svg",
	"./consultancy-cost": "./app/javascript/images/consultancy-cost.svg",
	"./consultancy-cost-white": "./app/javascript/images/consultancy-cost-white.svg",
	"./consultancy-cost-white.svg": "./app/javascript/images/consultancy-cost-white.svg",
	"./consultancy-cost.svg": "./app/javascript/images/consultancy-cost.svg",
	"./consultancy-image": "./app/javascript/images/consultancy-image.png",
	"./consultancy-image.png": "./app/javascript/images/consultancy-image.png",
	"./face-fit": "./app/javascript/images/face-fit.jpg",
	"./face-fit.jpg": "./app/javascript/images/face-fit.jpg",
	"./favicon": "./app/javascript/images/favicon.png",
	"./favicon.png": "./app/javascript/images/favicon.png",
	"./hand-arm-and-noise-assessments": "./app/javascript/images/hand-arm-and-noise-assessments.jpg",
	"./hand-arm-and-noise-assessments.jpg": "./app/javascript/images/hand-arm-and-noise-assessments.jpg",
	"./iatp": "./app/javascript/images/iatp.png",
	"./iatp.png": "./app/javascript/images/iatp.png",
	"./industrial-workers": "./app/javascript/images/industrial-workers.png",
	"./industrial-workers.png": "./app/javascript/images/industrial-workers.png",
	"./iosh": "./app/javascript/images/iosh.svg",
	"./iosh.svg": "./app/javascript/images/iosh.svg",
	"./ipaf": "./app/javascript/images/ipaf.svg",
	"./ipaf-poster": "./app/javascript/images/ipaf-poster.jpeg",
	"./ipaf-poster.jpeg": "./app/javascript/images/ipaf-poster.jpeg",
	"./ipaf.svg": "./app/javascript/images/ipaf.svg",
	"./ipaf_1b": "./app/javascript/images/ipaf_1b.png",
	"./ipaf_1b.png": "./app/javascript/images/ipaf_1b.png",
	"./ipaf_3a": "./app/javascript/images/ipaf_3a.png",
	"./ipaf_3a.png": "./app/javascript/images/ipaf_3a.png",
	"./ipaf_3b": "./app/javascript/images/ipaf_3b.png",
	"./ipaf_3b.png": "./app/javascript/images/ipaf_3b.png",
	"./logo": "./app/javascript/images/logo.svg",
	"./logo.svg": "./app/javascript/images/logo.svg",
	"./pasma-logo": "./app/javascript/images/pasma-logo.jpg",
	"./pasma-logo.jpg": "./app/javascript/images/pasma-logo.jpg",
	"./placeholder-news-image": "./app/javascript/images/placeholder-news-image.jpg",
	"./placeholder-news-image.jpg": "./app/javascript/images/placeholder-news-image.jpg",
	"./placeholder-review-avatar": "./app/javascript/images/placeholder-review-avatar.png",
	"./placeholder-review-avatar.png": "./app/javascript/images/placeholder-review-avatar.png",
	"./psma": "./app/javascript/images/psma.svg",
	"./psma.svg": "./app/javascript/images/psma.svg",
	"./safety-men-hivis": "./app/javascript/images/safety-men-hivis.png",
	"./safety-men-hivis.png": "./app/javascript/images/safety-men-hivis.png",
	"./times": "./app/javascript/images/times.svg",
	"./times.svg": "./app/javascript/images/times.svg",
	"./training-image": "./app/javascript/images/training-image.png",
	"./training-image.png": "./app/javascript/images/training-image.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/javascript/images sync recursive ^\\.\\/.*$";